import React from 'react';
import { PLAY_STORE_URL } from '../data/site';
import { isIosDevice } from '../utils/platform';
import './InstallApp.css';

const BADGE_SRC = `${process.env.PUBLIC_URL || ''}/badges/google-play-badge.png`;

export function PlayStoreBadge({ className = '' }) {
  return (
    <a
      className={`play-badge${className ? ` ${className}` : ''}`}
      href={PLAY_STORE_URL}
      target="_blank"
      rel="noopener noreferrer"
    >
      <img src={BADGE_SRC} alt="Get it on Google Play" />
    </a>
  );
}

function IphoneNote({ prominent }) {
  return (
    <div className={`iphone-note${prominent ? ' iphone-note-prominent' : ''}`}>
      <p className="iphone-note-title">Using an iPhone? Install it on your home screen.</p>
      <p className="iphone-note-steps">In Safari, tap Share, then 'Add to Home Screen'.</p>
    </div>
  );
}

// Homepage install block. On iPhone and iPad the home-screen steps lead,
// and the Play badge is replaced with a plain text link.
const InstallApp = ({ ios }) => {
  const apple = ios ?? isIosDevice();

  return (
    <section
      className={`install-app${apple ? ' install-app-ios' : ''}`}
      aria-labelledby="get-the-app-heading"
    >
      <h2 id="get-the-app-heading">Get the app</h2>
      <div className="install-app-options">
        {apple ? (
          <>
            <IphoneNote prominent />
            <a className="play-text-link" href={PLAY_STORE_URL} target="_blank" rel="noopener noreferrer">
              Get it on Google Play
            </a>
          </>
        ) : (
          <>
            <PlayStoreBadge />
            <IphoneNote />
          </>
        )}
      </div>
    </section>
  );
};

export default InstallApp;
